import React from "react";
import "./DeveloperCarousel.css";
import DeveloperCard from "./DeveloperCard/DeveloperCard";

export default function DeveloperCarousel({ title, devArr }) {
  return (
    <div className="developerCarouselWrapper">
      <h2 className="developerCarouselTitle">{title}</h2>
      <div className="developerCardsWrapper">
        {devArr.map((dev) => {
          return (
            <DeveloperCard
              imgUrl={dev.imgUrl}
              name={dev.nume}
              quote={dev.bio}
            />
          );
        })}
      </div>
    </div>
  );
}
